import axios from 'axios'
import { generateSign } from '@/utils/tools'
import { get, post } from './request'

// 获取付款记录
export const getOrderRecord = (data) => {
  return get('/answer/order_record', data)
}

// 获取订单信息
export const getPayOrder = async (data) => {
  const signParams = generateSign({
    path: '/payment/order/get_order_details',
    orgId: 29,
    secret: 'cb5a5965ccb9412cae8717612d0e251b'
  })


  const res = await axios.get(`${process.env.VUE_APP_PAY_API_URL}/order/get_order_details`, {
    params: {
      ...data,
      ...signParams
    },
    headers: {
      'CQ-TOKEN': data.token
    }
  })

  if (res.status === 200) {
    return res.data
  }
}

// h5 支付
export const payOrder = async (data) => {
  return post('/answer/wap_pay', data)
}
